import { CountryCode, FlagComponent, Icons } from '@commenda/kakashi';

interface Assignee {
  id: string;
  name: string;
  email: string;
}

interface ConfirmRemoveAssigneeStepProps {
  assigneeToRemove: Assignee | null;
  companyDisplayName?: string;
  companyCountryCode?: string;
}

export const ConfirmRemoveAssigneeStep = ({
  assigneeToRemove,
  companyDisplayName,
  companyCountryCode,
}: ConfirmRemoveAssigneeStepProps) => {
  return (
    <div className="flex flex-col gap-4xl p-3xl">
      <div className="flex flex-col items-start gap-md">
        <div className="flex items-center justify-center w-12 h-12 bg-utility-warning-50 rounded-lg border border-utility-warning-200">
          <Icons.AlertTriangle className="size-6 text-utility-warning-600" />
        </div>
        <div className="txt-large-bold text-text-primary flex items-center gap-sm">
          Are you sure? •
          {companyCountryCode && (
            <FlagComponent
              country={companyCountryCode as CountryCode}
              countryName={companyCountryCode}
              _className="size-4"
            />
          )}
          <span className="txt-medium-regular text-text-tertiary">
            {companyDisplayName}
          </span>
        </div>
      </div>

      <div className="flex flex-col gap-md">
        <p className="txt-medium-regular text-text-primary">
          You are removing the assignee{' '}
          <span className="font-medium">{assigneeToRemove?.name}</span>.
        </p>
      </div>
    </div>
  );
};
